export default "__VITE_ASSET__idNB0RGZ__"